
import React, {useState, useEffect} from 'react';

import GLOBALS from '../elements/Globals';
import Loader from '../elements/Loader';
import { Link } from 'react-router-dom';

const createMarkup = (htmlString) => {
  return { __html: htmlString };
};

const FightSchedules = (props) => {

  const [loading, setLoading] = useState(false);
  const [pagedata, setPagedata ]= useState("");

  useEffect(() => {
    setLoading(true)
    async function getData() {
      let apiUrl = 'cmspage?page_id=contact-us';
      const url = GLOBALS.API_BASE_URL+apiUrl;
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }
        const json = await response.json();
        setPagedata(json.data.content);
        setLoading(false)
      } catch (error) {
        console.error(error.message);
      }
    }
    getData();
    return () => {
      // Cleanup logic here
    };
  }, []);

  
  return (

    <>
    
    <div className="mvpBgContainer mvp_container" id="newsMainContent" style={{width: '100%'}}>
  {/* <div class="ad d-none d-md-block">
	<input type="hidden" name="IL_IN_ARTICLE">
</div> */}
  <div className="news_articles_content" style={{width: '100%'}}>
    <div className="left_content_area odds_section" style={{margin: 0, minHeight: 233}}>
      <h1 className="titles_article sch_title">Boxing Fight Schedule 2025 | MVP Boxing</h1>{/* ends (.sch_title) */}
      <ul className="sch_tabs">
        <li className="ative_tab"><Link to="/fights-schedule/boxing">Boxing</Link></li>
        <li><Link to="/fights-schedule/ufc-mma">MMA</Link></li>
        <li className="odds_powered_by d-none d-md-block">powered by<span>mvpboxing.com</span></li>
      </ul>{/* ends (.sch_tabs) */}
      <div className="odds-div">
        <div id="schedules_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer"><div className="row"><div className="col-sm-12 col-md-6"><div className="dataTables_length" id="schedules_length"><label>Show <select name="schedules_length" aria-controls="schedules" className="custom-select custom-select-sm form-control form-control-sm"><option value={10}>10</option><option value={25}>25</option><option value={50}>50</option><option value={100}>100</option></select> entries</label></div></div><div className="col-sm-12 col-md-6"><div id="schedules_filter" className="dataTables_filter"><label>Search:<input type="search" className="form-control form-control-sm" placeholder aria-controls="schedules" /></label></div></div></div><div className="row"><div className="col-sm-12"><table id="schedules" data-schedulestype="boxing" className="display dataTable no-footer" style={{width: '100%'}} role="grid" aria-describedby="schedules_info">
                <thead>
                  <tr role="row"><th className="oddsText sorting" tabIndex={0} aria-controls="schedules" rowSpan={1} colSpan={1} aria-label="
							Upcoming							Fight Schedules: activate to sort column ascending" style={{width: 297}}><h2 style={{fontSize: 20, fontWeight: '700 !important'}}>
                        Upcoming							Fight Schedules</h2></th></tr>
                </thead>
                <tbody><tr className="odd"><td valign="top" colSpan={1} className="dataTables_empty">No Upcoming Fight Schedules currently</td></tr></tbody></table></div></div><div className="row"><div className="col-sm-12 col-md-5"><div className="dataTables_info" id="schedules_info" role="status" aria-live="polite">Showing 0 to 0 of 0 entries</div></div><div className="col-sm-12 col-md-7"><div className="dataTables_paginate paging_simple_numbers" id="schedules_paginate"><ul className="pagination"><li className="paginate_button page-item previous disabled" id="schedules_previous"><a href="#" aria-controls="schedules" data-dt-idx={0} tabIndex={0} className="page-link">Previous</a></li><li className="paginate_button page-item next disabled" id="schedules_next"><a href="#" aria-controls="schedules" data-dt-idx={1} tabIndex={0} className="page-link">Next</a></li></ul></div></div></div></div>
      </div>
      <div className="odds-div">
        <div id="schedules-old_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer"><div className="row"><div className="col-sm-12 col-md-6"><div className="dataTables_length" id="schedules-old_length"><label>Show <select name="schedules-old_length" aria-controls="schedules-old" className="custom-select custom-select-sm form-control form-control-sm"><option value={10}>10</option><option value={25}>25</option><option value={50}>50</option><option value={100}>100</option></select> entries</label></div></div><div className="col-sm-12 col-md-6"><div id="schedules-old_filter" className="dataTables_filter"><label>Search:<input type="search" className="form-control form-control-sm" placeholder aria-controls="schedules-old" /></label></div></div></div><div className="row"><div className="col-sm-12"><table id="schedules-old" data-schedulestype="boxing" className="display dataTable no-footer" style={{width: '100%'}} role="grid" aria-describedby="schedules-old_info">
                <thead>
                  <tr role="row"><th className="oddsText sorting" tabIndex={0} aria-controls="schedules-old" rowSpan={1} colSpan={1} aria-label="
							Previous							Fight Schedules: activate to sort column ascending" style={{width: 297}}><h2 style={{fontSize: 20, fontWeight: '700 !important'}}>
                        Previous							Fight Schedules</h2></th></tr>
                </thead>
                <tbody><tr role="row" className="odd"><td><div className="event_date mt-0">February 12, 2022</div>{/* ends (.event_date) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Daniel Jacobs  vs John Ryder </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Super Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London  (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Ellie Scotney vs Jorgelina Guanini</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Jr. Featherweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London  (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Felix Cash  vs Magomed Madiev </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Johnny Fisher  vs Gabriel Enguema</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Heavyweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London  (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Cyrus Pattinson  vs Evgenii Vazem</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Welterweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Jordan Reynolds vs CJ Wood</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Jr. Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Hopey Price  vs TBA </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Jr. Featherweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London, (ESPN)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Hopey Price  vs TBA </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Jr. Featherweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London, (ESPN)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}</td></tr><tr role="row" className="even"><td><div className="event_date ">February 11, 2022</div>{/* ends (.event_date) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Danny Dignum vs Grant Dennis </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Lee McGregor  vs Diego Alberto Ruiz </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Bantamweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London, (ESPN+) </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Nina Hughes  vs Bec Connolly</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Jr. Featherweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London  (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Joe Giles  vs Lewis van Poetsch</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Super Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London  (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>William Hamilton  vs Jone Volau</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Cruiseerweght </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London  (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Jordan Flynn vs Lee Hallett </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London  (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Jordan Flynn  vs Lee Hallet </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London  (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Shiloh Defeitas  vs Alexy Tukhtarov</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Welterweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Jamie Robinson  vs TBA </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Jr. Welterweight</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London  (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Bilal Fawaz  vs Vladimir Fleischhauer</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Jr. Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London  (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>George Mitchell  vs Vasif Mamedov </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Jr. Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>London  (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}</td></tr><tr role="row" className="odd"><td><div className="event_date ">February 06, 2022</div>{/* ends (.event_date) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>David Cuellar  vs Dixon Flores</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Jr.Featherweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Cancun, Mexico (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Christopher Lopez vs Dixon Flores </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Jr. Featherweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Cancun, Mexico (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Rosario Sanchez vs Fransisco Lucero </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Cancun, Mexico (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Oziel Santoyo vs Angel Herrera </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Cancun, Mexico (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}</td></tr><tr role="row" className="even"><td><div className="event_date ">January 29, 2022</div>{/* ends (.event_date) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Robson Conceicao vs Xavier Martinez </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Jr. Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Tulsa, Oklahoma (ESPN+) </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Rene Tellez Giron  vs Luis Melendez</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Jr. Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Tulsa, Oklahoma (ESPN+) </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Nico Ali Walsh  vs Jeremiah Yeager</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Tulsa, Oklahoma  (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Tiger Johnson vs Xavier Madrid </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Welterweight</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Tulsa, Oklahoma (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}</td></tr><tr role="row" className="odd"><td><div className="event_date ">January 27, 2022</div>{/* ends (.event_date) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Sergio Martinez  vs Macaulay McGowan </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Madrid, Spain </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Sergio Martinez  vs Macaulay McGowan </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Madrid, Spain </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}</td></tr><tr role="row" className="even"><td><div className="event_date ">December 18, 2021</div>{/* ends (.event_date) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Joseph Parker  vs Derek Chisora </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Heavyweight</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Manchester, England </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Carlos Gongora vs Lerrone Richards </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Super Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Manchester, England </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Zelfa Barrett  vs Bruno Tarimo </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Manchester, England </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Zelfa Barrett  vs Bruno Tarimo </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Manchester, England </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Lee McGregor  vs Narek Abgaryan </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Bantamweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Manchester, England </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Jack Cullen  vs Emre Cukur</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Super Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Manchester, England </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Gilberto Ramirez vs Yunieski Gonzalez </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Light Heavyweight (DAZN)</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>San Antonio, TX (USA)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Seniesa Estrada vs Maria Santizo </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Jr.Flyweight (WBO)</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>San Antonio, TX (USA) </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Lamont Roach Jr. vs Rene Alvarado </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Jr.Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>San Antonio, TX (USA) DAZN</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Marlen Esparza vs Anabel Ortiz </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Flyweight (WBC) Female </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>San Antonio, TX (USA) </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Yokasta Valle vs TBA</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Strawweight IBF</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>San Jose, Costa Rica </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}</td></tr><tr role="row" className="odd"><td><div className="event_date ">December 17, 2021</div>{/* ends (.event_date) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Artur Beterbiev vs Marcus Browne </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Light Heavyweight (WBC/ IBF)</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Montreal, Canada (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Marie Eve Decaire  vs Cynthia Lozano</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Jr. Middleweight ( Female)</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Montreal, Canada ( ESPN +)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Yan Pellerin vs Francisco Rivas </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Cruiserweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Montreal,Canada (ESPN+) </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Steve Rolls  vs Christopher Brooker </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Super Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Montreal, Canada (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Movladdin Biyarsslanov  vs Alan Ayala Crisosto </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Jr.Welterweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Montreal, Canada (ESPN +)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Brandon Moore  vs Abraham Pascual </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Heavyweight</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Montreal, Canada (ESPN +)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Mazlum Akdeniz  vs Arturo Bustamante </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Jr. Welterweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Montreal, Canada (ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Troy Isley  vs TBA</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Jr.Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Montreal, Canada (ESPN +)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Eric Basran  vs Ariel Gonzalez Vazquez </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Montreal, Canada (ESPN +)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}</td></tr><tr role="row" className="even"><td><div className="event_date ">December 14, 2021</div>{/* ends (.event_date) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Naoya Inoue  vs Aran Dipaen </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, WBA/IBF Bantamweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Tokyo, Japan </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Wilfredo Mendez vs Masataka Taniguchi</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, WBO Strawweight</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Tokyo, Japan</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Yoshiki Takei vs Kazuhiro Imamura</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Jr. Featherweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Tokyo, Japan </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Keisuke Matsumoto vs Takahiro Araki</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Jr.Featherweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Tokyo, Japan </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Toshiba Ishii vs Takuya Fujioka</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Jr.Featherweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Tokyo, Japan </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Yukio Kajitani vs Sho Nagasato</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Flyweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Tokyo,Japan </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Shuhei Kubata vs Haruki Takai</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Featherweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Tokyo, Japan </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>K.O. CP Freshmart vs Robert Paradero</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Strawweight</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Phuket, Thailand </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}</td></tr><tr role="row" className="odd"><td><div className="event_date ">December 11, 2021</div>{/* ends (.event_date) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Vasiliy Lomachenko  vs Richard Commey </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Lightweights </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>NYC (USA)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Jared Anderson  vs Oleksander Teslenko</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Heavyweight</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>NYC (ESPN DEPORTES/ ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Xander Zayas  vs Mastronunzio</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Jr. Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>NYC (ESPN DEPORTES/ ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Nico Ali Walsh  vs Reyes Sanchez </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>NYC (ESPN DEPORTES/ ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Keyshawn Davis  vs Jose Zaragoza </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>NYC (ESPN DEPORTES/ ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Pablo Valdez vs Julio Cesar Sanchez</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Welterweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>NYC (ESPN DEPORTES/ ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Kelvin Davis  vs Bryan Ramirez </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>4 Rounds, Welterweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>NYC (ESPN DEPORTES/ ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>John Bauza  vs Michael Williams Jr.</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Jr. Welterweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>NYC (ESPN DEPORTES/ ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>James Wilkins  vs Juan Tapia </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Featherweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>NYC (ESPN DEPORTES/ ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Joe Ward  vs Britton Norwood </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Light Heavyweight</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>NYC (ESPN DEPORTES/ ESPN+)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Nonito Donaire  vs Reymart Gaballo </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Bantamweight, WBC </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Carson, CA (SHOWTIME )</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Brandon Lee  vs Juan Heraldez </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Jr. Welterweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Carson, CA (SHOWTIME) </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Katie Taylor  vs Firuza Sharipova </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, WBC/ WBA/ WBO/ IBF </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Liverpool, England (DAZN)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Conor Benn  vs Chris Algieri </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Welterweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Liverpool, England ( DAZN)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Jordan Gill  vs Karim Guerfi </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Featherweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Liverpool, England ( DAZN)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Robbie Davies  vs Henry Lundy </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Jr. Welterweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Liverpool, England ( DAZN)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Caoimhin Agyarko vs Noe Larios Jr. </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Liverpool, England ( DAZN)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Joe Cordina  vs TBA </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Jr. Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Liverpool, England ( DAZN)</label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Joe Riel Casimero  vs Paul Butler </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, WBO Bantamweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Dubai, U.A.E. </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Sunny Edwards  vs Jayson Mama </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, IBF Flyweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Dubai, U.A.E. </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Donnie Nietes  vs TBA </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Jr. Batamweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Dubai, U.A.E. </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Archie Sharp  vs TBA </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Jr. Lightweight</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Dubai, U.A.E. </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Jono Carroll vs TBA </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>8 Rounds, Jr.Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Dubai, U.A.E. </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Magomed Kurbanov  vs Patrick Teixeira </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Jr. Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Ekaterinburg, Russia </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Magomed Kurbanov  vs Patrick Teixeira</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Jr. Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Ekaterinburg, Russia </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Dmitry Bivol  vs Umar Salamov </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, WBA Light Heavyweight title </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Ekaterinburg, Russia </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Dmitry Bivol  vs Umar Salamov </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, WBA Light Heavyweight title </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Ekaterinburg, Russia </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Eduard Skavynskyi vs TBA </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, WBC Welterweight Eliminator </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Ekaterinburg, Russia </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Ruslan Kamilov  vs Dmitrii Khassiev </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Jr. Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Ekaterinburg, Russia </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Ruslan Kamilov  vs Dmitrii Khasiev </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Jr. Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Ekaterinburg, Russia </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Rakhimov  vs Oladosu</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Jr. Lightweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Ekaterinburg, Russia </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Artysh Lopsan  vs Ramil Gadzhyiev </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>10 Rounds, Super Middleweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Ekaterinburg, Russia </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Yaroslav Doronichev vs Alexander Zubkov</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Cruiserweight </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Ekaterinburg, Russia </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}<div className="odds_info event_info" style={{backgroundColor: '#EEEEEE'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Kushitashvili  vs TBA </label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>6 Rounds, Light Heavyweight</label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Ekaterinburg, Russia </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}</td></tr><tr role="row" className="even"><td><div className="event_date ">December 09, 2021</div>{/* ends (.event_date) */}<div className="odds_info event_info" style={{backgroundColor: '#FFFFFF'}}>
                        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                          <tbody><tr className="row mx-0">
                              <td className="col-12 px-0 col-md-4 text-md-left">
                                <label>Victorio Saludar  vs Erick Rosa Pacheco</label></td>
                              <td className="col-12 px-0 col-md-4">
                                <label>12 Rounds, Saludar’s WBA Strawweight Title </label>
                              </td>
                              <td className="col-12 px-0 col-md-4 text-md-right text-sm-left">
                                <label>Santo Domingo, Dominican Republic </label>
                              </td>
                            </tr>
                          </tbody></table>
                      </div>{/* class (.event_info) */}</td></tr></tbody></table></div></div><div className="row"><div className="col-sm-12 col-md-5"><div className="dataTables_info" id="schedules-old_info" role="status" aria-live="polite">Showing 1 to 10 of 113 entries</div></div><div className="col-sm-12 col-md-7"><div className="dataTables_paginate paging_simple_numbers" id="schedules-old_paginate"><ul className="pagination"><li className="paginate_button page-item previous disabled" id="schedules-old_previous"><a href="#" aria-controls="schedules-old" data-dt-idx={0} tabIndex={0} className="page-link">Previous</a></li><li className="paginate_button page-item active"><a href="#" aria-controls="schedules-old" data-dt-idx={1} tabIndex={0} className="page-link">1</a></li><li className="paginate_button page-item "><a href="#" aria-controls="schedules-old" data-dt-idx={2} tabIndex={0} className="page-link">2</a></li><li className="paginate_button page-item "><a href="#" aria-controls="schedules-old" data-dt-idx={3} tabIndex={0} className="page-link">3</a></li><li className="paginate_button page-item "><a href="#" aria-controls="schedules-old" data-dt-idx={4} tabIndex={0} className="page-link">4</a></li><li className="paginate_button page-item "><a href="#" aria-controls="schedules-old" data-dt-idx={5} tabIndex={0} className="page-link">5</a></li><li className="paginate_button page-item disabled" id="schedules-old_ellipsis"><a href="#" aria-controls="schedules-old" data-dt-idx={6} tabIndex={0} className="page-link">…</a></li><li className="paginate_button page-item "><a href="#" aria-controls="schedules-old" data-dt-idx={7} tabIndex={0} className="page-link">12</a></li><li className="paginate_button page-item next" id="schedules-old_next"><a href="#" aria-controls="schedules-old" data-dt-idx={8} tabIndex={0} className="page-link">Next</a></li></ul></div></div></div></div>
      </div>
      <div className="odds_pager">
        <ul className="sch_tabs">
          <li className="odds_powered_by d-block d-md-none">powered by <span style={{display: 'inline-block'}}>mvpboxing.com</span></li>
        </ul>
        <div className="clear" />
      </div>{/* ends (.odds_pager) */}
      <div className="content-separator">&nbsp;</div>{/* ends (.content-separator) */}
     <div className="socialInfo">
          <div className="text-center social-sharing-info bottom-social-share">
         <p className="social-share-block"><i className="share-icon fas fa-share-alt" aria-hidden="true" /><span className="social-icons a2a_kit a2a_kit_size_32 a2a_default_style" style={{lineHeight: 0}}><a className="a2a_button_facebook" href="/#facebook" title="Facebook" target="_blank" rel="nofollow noopener"><span className="a2a_svg a2a_s__default a2a_s_facebook" style={{backgroundColor: 'rgb(8, 102, 255)'}}><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill="#fff" d="M28 16c0-6.627-5.373-12-12-12S4 9.373 4 16c0 5.628 3.875 10.35 9.101 11.647v-7.98h-2.474V16H13.1v-1.58c0-4.085 1.849-5.978 5.859-5.978.76 0 2.072.15 2.608.298v3.325c-.283-.03-.775-.045-1.386-.045-1.967 0-2.728.745-2.728 2.683V16h3.92l-.673 3.667h-3.247v8.245C23.395 27.195 28 22.135 28 16" /></svg></span><span className="a2a_label">Facebook</span></a><a className="a2a_button_twitter" href="/#twitter" title="Twitter" target="_blank" rel="nofollow noopener"><span className="a2a_svg a2a_s__default a2a_s_twitter" style={{backgroundColor: 'rgb(29, 155, 240)'}}><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill="#FFF" d="M28 8.557a10 10 0 0 1-2.828.775 4.93 4.93 0 0 0 2.166-2.725 9.7 9.7 0 0 1-3.13 1.194 4.92 4.92 0 0 0-3.593-1.55 4.924 4.924 0 0 0-4.794 6.049c-4.09-.21-7.72-2.17-10.15-5.15a4.94 4.94 0 0 0-.665 2.477c0 1.71.87 3.214 2.19 4.1a5 5 0 0 1-2.23-.616v.06c0 2.39 1.7 4.38 3.952 4.83-.414.115-.85.174-1.297.174q-.476-.001-.928-.086a4.935 4.935 0 0 0 4.6 3.42 9.9 9.9 0 0 1-6.114 2.107q-.597 0-1.175-.068a13.95 13.95 0 0 0 7.55 2.213c9.056 0 14.01-7.507 14.01-14.013q0-.32-.015-.637c.96-.695 1.795-1.56 2.455-2.55z" /></svg></span><span className="a2a_label">Twitter</span></a>
         <a className="a2a_button_whatsapp" href="/#whatsapp" title="WhatsApp" target="_blank" rel="nofollow noopener"><span className="a2a_svg a2a_s__default a2a_s_whatsapp" style={{backgroundColor: 'rgb(18, 175, 10)'}}><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill="#FFF" fillRule="evenodd" d="M16.21 4.41C9.973 4.41 4.917 9.465 4.917 15.7c0 2.134.592 4.13 1.62 5.832L4.5 27.59l6.25-2.002a11.24 11.24 0 0 0 5.46 1.404c6.234 0 11.29-5.055 11.29-11.29 0-6.237-5.056-11.292-11.29-11.292m0 20.69c-1.91 0-3.69-.57-5.173-1.553l-3.61 1.156 1.173-3.49a9.35 9.35 0 0 1-1.79-5.512c0-5.18 4.217-9.4 9.4-9.4s9.397 4.22 9.397 9.4c0 5.188-4.214 9.4-9.398 9.4zm5.293-6.832c-.284-.155-1.673-.906-1.934-1.012-.265-.106-.455-.16-.658.12s-.78.91-.954 1.096c-.176.186-.345.203-.628.048-.282-.154-1.2-.494-2.264-1.517-.83-.795-1.373-1.76-1.53-2.055s0-.445.15-.584c.134-.124.3-.326.45-.488.15-.163.203-.28.306-.47.104-.19.06-.36-.005-.506-.066-.147-.59-1.587-.81-2.173-.218-.586-.46-.498-.63-.505-.168-.007-.358-.038-.55-.045-.19-.007-.51.054-.78.332-.277.274-1.05.943-1.1 2.362-.055 1.418.926 2.826 1.064 3.023.137.2 1.874 3.272 4.76 4.537 2.888 1.264 2.9.878 3.43.85.53-.027 1.734-.633 2-1.297s.287-1.24.22-1.363c-.07-.123-.26-.203-.54-.357z" clipRule="evenodd" /></svg></span><span className="a2a_label">WhatsApp</span></a><a className="a2a_button_facebook_messenger" href="/#facebook_messenger" title="Facebook Messenger" target="_blank" rel="nofollow noopener"><span className="a2a_svg a2a_s__default a2a_s_facebook_messenger" style={{backgroundColor: 'rgb(0, 132, 255)'}}><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill="#FFF" d="M16 5C9.986 5 5.11 9.56 5.11 15.182c0 3.2 1.58 6.054 4.046 7.92V27l3.716-2.06c.99.276 2.04.425 3.128.425 6.014 0 10.89-4.56 10.89-10.183S22.013 5 16 5m1.147 13.655L14.33 15.73l-5.423 3 5.946-6.31 2.816 2.925 5.42-3-5.946 6.31z" /></svg></span><span className="a2a_label">Messenger</span></a>
         <a className="a2a_button_reddit" href="/#reddit" title="Reddit" target="_blank" rel="nofollow noopener"><span className="a2a_svg a2a_s__default a2a_s_reddit" style={{backgroundColor: 'rgb(255, 69, 0)'}}><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill="#fff" d="M28.543 15.774a2.953 2.953 0 0 0-2.951-2.949 2.88 2.88 0 0 0-1.9.713 14.1 14.1 0 0 0-6.85-2.044l1.38-4.349 3.768.884a2.452 2.452 0 1 0 .24-1.176l-4.274-1a.6.6 0 0 0-.709.4l-1.659 5.224a14.3 14.3 0 0 0-7.316 2.029 2.9 2.9 0 0 0-1.872-.681 2.942 2.942 0 0 0-1.618 5.4 5 5 0 0 0-.062.765c0 4.158 5.037 7.541 11.229 7.541s11.22-3.383 11.22-7.541a5 5 0 0 0-.053-.706 2.96 2.96 0 0 0 1.427-2.51m-18.008 1.88a1.753 1.753 0 0 1 1.73-1.74 1.73 1.73 0 0 1 1.709 1.74 1.71 1.71 0 0 1-1.709 1.711 1.733 1.733 0 0 1-1.73-1.711m9.565 4.968a5.57 5.57 0 0 1-4.081 1.272h-.032a5.58 5.58 0 0 1-4.087-1.272.6.6 0 0 1 .844-.854 4.5 4.5 0 0 0 3.238.927h.032a4.5 4.5 0 0 0 3.237-.927.6.6 0 1 1 .844.854zm-.331-3.256a1.726 1.726 0 1 1 1.709-1.712 1.717 1.717 0 0 1-1.712 1.712z" /></svg></span><
         span className="a2a_label">Reddit</span></a><a className="a2a_button_pinterest" href="/#pinterest" title="Pinterest" target="_blank" rel="nofollow noopener"><span className="a2a_svg a2a_s__default a2a_s_pinterest" style={{backgroundColor: 'rgb(230, 0, 35)'}}><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill="#fff" d="M15.995 4C9.361 4 4 9.37 4 15.995c0 5.084 3.16 9.428 7.622 11.176-.109-.948-.198-2.41.039-3.446.217-.938 1.402-5.963 1.402-5.963s-.356-.72-.356-1.777c0-1.668.968-2.912 2.172-2.912 1.027 0 1.52.77 1.52 1.688 0 1.027-.65 2.567-.996 3.998-.287 1.195.602 2.172 1.777 2.172 2.132 0 3.771-2.25 3.771-5.489 0-2.873-2.063-4.877-5.015-4.877-3.416 0-5.42 2.557-5.42 5.203 0 1.027.395 2.132.888 2.735a.36.36 0 0 1 .08.345c-.09.375-.297 1.195-.336 1.363-.05.217-.178.266-.405.158-1.481-.711-2.409-2.903-2.409-4.66 0-3.781 2.745-7.257 7.928-7.257 4.156 0 7.394 2.962 7.394 6.931 0 4.137-2.606 7.464-6.22 7.464-1.214 0-2.36-.632-2.744-1.383l-.75 2.854c-.267 1.046-.998 2.35-1.491 3.149a12 12 0 0 0 3.554.533C22.629 28 28 22.63 28 16.005 27.99 9.37 22.62 4 15.995 4" />
         </svg></span><span className="a2a_label">Pinterest</span></a><a className="a2a_button_email" href="/#email" title="Email" target="_blank" rel="nofollow noopener"><span className="a2a_svg a2a_s__default a2a_s_email" style={{backgroundColor: 'rgb(136, 137, 144)'}}><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill="#fff" d="M27 21.775v-9.9s-10.01 6.985-10.982 7.348C15.058 18.878 5 11.875 5 11.875v9.9c0 1.375.293 1.65 1.65 1.65h18.7c1.393 0 1.65-.242 1.65-1.65m-.017-11.841c0-1.002-.291-1.359-1.633-1.359H6.65c-1.38 0-1.65.429-1.65 1.43l.016.154s9.939 6.842 11 7.216C17.14 16.941 27 10.005 27 10.005z" /></svg></span><span className="a2a_label">Email</span></a></span></p><div style={{clear: 'both'}} /><p /></div>
        </div>
      <div className="clear" />
      {/* <div class="mvp-comment-box"></div> */}
      {/* ends (.mvp-comment-box) */}
      <div id="comment-policy" className="comment-policy publisher-anchor-color  ">
        <div className="content">
          <h2 className="title">MVPBOXING.COM Comment Policy
            <i aria-hidden="true" className="fa fa-5x fa-comments-o " />
          </h2>
          <p>"Hey, why isn't my comment displaying?!"</p>
          <p>Please read our <a href="/comment_policy" target="_blank" className="policy-link">Comment Policy</a> before commenting.</p>
        </div>
      </div>
      <div className="comments">
        <div className="main-title w-100 row mx-0"><div className="col-7 pl-1"><i className="fa fa-comments-o" aria-hidden="true" /> <span id="total_comments">0</span> <span>Comments</span></div>
          <div id="share-block" className="col-5 text-right pr-1"><i className="fa fa-share-alt" aria-hidden="true" /> Share</div>
        </div>
      </div>
    </div>{/* ends (.socialInfo) */}
  </div>{/* ends (.left_content_area) */}
  {/* <div class="ad">
  <input type="hidden" name="IL_IN_ARTICLE">
    </div> */}
</div>

    
    
    </>


  )
};

export default FightSchedules;